<script setup lang="ts">

import { type ColorPalette, useFabricStore } from '@/store/fabric.ts';
import { computed } from 'vue';

const fabricStore = useFabricStore();

const regionColor = computed(() => {
  let srcImage = fabricStore.fabricInfo?.mask?.srcImage;
  if (!srcImage)
    return [];
  let value = fabricStore.fabricInfo?.mask?.colors?.map((x:string, index:number)=>{
    let oPalette:ColorPalette = {colorNo : "",color : "", colorName :""};
    oPalette.color = x;
    oPalette.colorNo = String(index + 1);
    return oPalette;
  });

  return value || [];
});

const onClickColor = (index: number) => {
  fabricStore.setSelectedRegionIndex(index);
};

</script>

<template>
  <div v-if="regionColor && regionColor.length > 0" :class="$style.container">
    <div
      v-for="(p, index) of regionColor"
      :key="p.colorNo"
      :class="[$style.colorBlock, { [$style.selected]: fabricStore.selectedRegionIndex === index }]"
      :style="{ backgroundColor: p.color }"
      @click="()=>onClickColor(index)"
    />
  </div>
</template>

<style module>
.container {
  padding: 20px 10px 50px;
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.colorBlock {
  width: 30px;
  height: 30px;
  cursor: pointer;
  border: 2px solid transparent;
  border-radius: 4px;
  transition: all 0.2s ease;
  box-sizing: border-box;
}

.colorBlock:hover {
  transform: scale(1.1);
}

.colorBlock.selected {
  border-color: #1890ff;
  box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2);
  transform: scale(1.05);
}
</style>
